import { useEffect, useState } from "react";
import Head from "next/head";
import PreCSS from "../../src/utils/preRenderCSS";

import Link from "../../src/components/Link";
import axios from "axios";

import Interweave from "interweave";
import useWindowSize from "../../src/utils/useWindowSize";

import { ptToVwConverter, convertDate } from "../../src/utils";

import {
  DecorationLine,
  TopContentsTitleContainer,
  TopContentsTitle,
  TopContentsContainer,
} from "../../src/components/style";
import {
  PreviousNextButton,
  NewsContainer,
  NewsMain,
  LinkButton,
  LinkInsideContainer,
  NewsPhoto,
  NewsPhotoAlt,
  TextContainer,
  NewsSmallTitle,
  NewsText,
  PaginationContainer,
  PaginationMain,
} from "../../src/components/style/news";

function News({ news, lang }: { news: News[]; lang: string }) {
  const windowSize = useWindowSize();

  useEffect(() => {
    const textContainers = document.getElementsByClassName("textContainer");
    for (let i = 0; i < textContainers.length; i++) {
      const container = textContainers[i] as HTMLElement;
      const p = container.getElementsByTagName("p")[0];
      if (p) {
        p.style.display = "block";
        p.style.width = `${container.clientWidth - 20}px`;
        p.style.height = "18px";
        p.style.whiteSpace = "nowrap";
        p.style.overflow = "hidden";
        p.style.textOverflow = "ellipsis";
      }
      container.innerHTML = "";
      // FIXME: removed this due to the bug
      // container.appendChild(p);
    }
  });

  const pageLimit = 10;
  const length = news.length;

  const [current, setCurrent] = useState(1);
  const [previous, setPrevious] = useState(0);
  const [next, setNext] = useState(length > pageLimit ? 2 : 0);

  const clickPrevious = () => {
    setCurrent(current - 1);
    setPrevious(previous - 1);
    if (next !== 0) {
      setNext(next - 1);
    } else {
      setNext(Math.ceil(length / pageLimit));
    }
    window.scrollTo({
      top: 0,
    });
  };

  const clickNext = () => {
    setCurrent(current + 1);
    setPrevious(previous + 1);
    if (Math.ceil(length / pageLimit) === next) {
      setNext(0);
    } else {
      setNext(next + 1);
    }
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <div>
      <Head>
        <title>zerO ニュース</title>
        <meta property="og:title" content="zerO ニュース" />
        <meta property="og:description" content="zerO ニュース一覧ページ" />
        <meta property="og:image" content="/assets/logoShare.jpg" />
        <meta property="og:url" content="https://zero-dance.com/news/" />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <PreCSS />
      <NewsContainer>
        <TopContentsContainer>
          {windowSize === "desktop" ? (
            <>
              <TopContentsTitleContainer>
                <TopContentsTitle>news</TopContentsTitle>
              </TopContentsTitleContainer>
              <DecorationLine />
            </>
          ) : windowSize === "tablet" || windowSize === "mobile" ? (
            <>
              <div
                style={{
                  fontSize: "18px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontWeight: 400,
                }}
              >
                news
              </div>
              <DecorationLine />
            </>
          ) : (
            <p></p>
          )}

          <NewsMain>
            {lang ? (
              news.length ? (
                news
                  .filter((_, i) => {
                    return previous * pageLimit <= i && i < current * pageLimit;
                  })
                  .map((item, i) => {
                    const as = `/news/${item.id}`;
                    return (
                      <LinkButton key={i}>
                        <Link href="/news/[id]" as={as}>
                          <LinkInsideContainer>
                            {item.imgMain ? (
                              <NewsPhoto
                                src={item.imgMain?.url}
                                alt={item.title}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                              />
                            ) : (
                              <NewsPhotoAlt />
                            )}
                            <TextContainer>
                              <NewsSmallTitle>
                                {lang === "ja"
                                  ? item.title
                                  : lang === "en"
                                  ? item.titleEng
                                  : ""}
                              </NewsSmallTitle>
                              <NewsText>
                                {lang === "ja"
                                  ? item.subTitle
                                  : lang === "en"
                                  ? item.subTitleEng
                                  : ""}
                              </NewsText>
                              <NewsText>
                                {convertDate(item.publishedAt)}
                              </NewsText>
                              <div
                                style={{
                                  color: "#4d4d4d",
                                  fontSize: "12px",
                                  marginTop: `${ptToVwConverter(18)}vw`,
                                }}
                                className="textContainer"
                              >
                                {lang === "ja" ? (
                                  <Interweave content={item.body} />
                                ) : lang === "en" ? (
                                  <Interweave content={item.bodyEng} />
                                ) : (
                                  ""
                                )}
                              </div>
                            </TextContainer>
                          </LinkInsideContainer>
                        </Link>
                      </LinkButton>
                    );
                  })
              ) : (
                <div
                  style={{
                    color: "white",
                  }}
                >
                  {lang === "ja"
                    ? "表示する情報がありません。"
                    : "No item found."}
                </div>
              )
            ) : (
              <></>
            )}

            <PaginationContainer>
              {previous ? (
                <PreviousNextButton onClick={clickPrevious}>
                  {"<"}
                </PreviousNextButton>
              ) : (
                <></>
              )}
              <PaginationMain>
                <div>
                  {current}/{Math.ceil(length / pageLimit)} PAGE
                </div>
              </PaginationMain>
              {next ? (
                <PreviousNextButton onClick={clickNext}>
                  {">"}
                </PreviousNextButton>
              ) : (
                <></>
              )}
            </PaginationContainer>
          </NewsMain>
        </TopContentsContainer>
      </NewsContainer>
    </div>
  );
}

export async function getStaticProps() {
  const baseURL = process.env.MICRO_URL;

  const newsURL = baseURL + "news?limit=1000";

  const config = {
    headers: {
      "X-API-KEY": process.env.MICRO_API_KEY,
    },
  };

  const newsResponse: NewsResponse = await axios.get(newsURL, config);

  const news = newsResponse.data.contents.sort((a, b) => {
    const recent = new Date(a.publishedAt).getTime();
    const old = new Date(b.publishedAt).getTime();
    return old - recent;
  });

  return {
    props: {
      news,
      namespacesRequired: [],
    },
  };
}

export default News;
